<template>
	<a v-if="route.name.startsWith('index')" class="scroll-down smooth-scroll" @click="scrollDown()">
		<span>{{ content }}</span>
		<div />
	</a>
</template>

<script setup>
const route = useRoute();

defineProps({
	content: { type: String, default: '' },
});

const scrollDown = () => {
	smoothScrollTo(window.innerHeight, 800);
};

function smoothScrollTo(targetPosition, duration) {
	const startPosition = window.scrollY;
	const distance = targetPosition - startPosition;
	let startTime = null;

	function animation(currentTime) {
		if (startTime === null) {
			startTime = currentTime;
		}
		const timeElapsed = currentTime - startTime;

		// Ease-in-out function for smoother scrolling
		const ease = (t) => t * (2 - t);

		// prettier-ignore
		const run = (ease(Math.min(timeElapsed / duration, 1)) * distance) + startPosition;
		window.scrollTo(0, run);

		if (timeElapsed < duration) {
			requestAnimationFrame(animation);
		}
	}

	requestAnimationFrame(animation);
}
</script>

<style lang="scss" scoped>
.scroll-down {
	position: absolute;
	cursor: pointer;
	bottom: 45px;
	left: 0;
	right: 0;
	margin: 0 auto;
	z-index: 2;
	display: flex;
	flex-flow: column wrap;
	justify-content: center;
	align-items: center;
	font-family: var(--heading-font-family);
	text-transform: lowercase;
	animation: fade-from-bottom 1s ease;

	span {
		color: var(--nav-color-light);
		margin: 0 0 20px;
		font-size: 24px;
		letter-spacing: 1px;
	}

	div {
		background: url('~/assets/images/icon-scroll-down.svg') no-repeat center center;
		width: 46px;
		height: 13px;
		background-size: 46px;
	}
}

@media (max-height: 780px) {
	.scroll-down {
		bottom: 95px;

		span {
			color: var(--nav-color-light);
			margin: 0 0 15px;
			font-size: 28px;
		}
	}
}

@media (max-width: 880px) {
	.scroll-down {
		bottom: 95px;

		span {
			text-align: center;
			margin: 0 0 15px;
			font-size: 20px;
		}
	}
}
</style>
